<!-- UNIVAPLAT-3699: deactivate organisation modal (role/aria-modal/focus trap come from NgbModal) -->
<div class="modal-header">
    <h1 class="modal-title fs-5 fw-normal" id="deactivate-organisation-title" data-testid="deactivate-organisation-title">Confirm the action</h1>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss(false)"
            data-testid="deactivate-organisation-close"></button>
</div>
<div class="modal-body">
    <p id="deactivate-organisation-description" data-testid="deactivate-organisation-description">Are you sure you want to deactivate this organisation?</p>
    <p>A deactivated organisation becomes read-only until it is reactivated.</p>
    <label for="deactivate-organisation-reason" class="form-label">Reason (optional)</label>
    <textarea id="deactivate-organisation-reason" class="form-control" rows="3"
              [formControl]="reason"
              [class.is-invalid]="reason.invalid"
              [attr.aria-invalid]="reason.invalid"
              aria-describedby="deactivate-organisation-reason-hint deactivate-organisation-reason-error"
              data-testid="deactivate-organisation-reason"></textarea>
    <div id="deactivate-organisation-reason-hint" class="form-text" role="status" aria-live="polite">{{ length }} / {{ maxLength }} characters</div>
    <div id="deactivate-organisation-reason-error" aria-live="polite">
        @if (reason.errors?.['maxlength']) {
            <div class="invalid-feedback d-block" data-testid="deactivate-organisation-reason-error">
                The reason must be {{ maxLength }} characters or fewer.
            </div>
        }
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-gray text-dark" (click)="modal.dismiss(false)"
            data-testid="deactivate-organisation-cancel">No, cancel</button>
    <button type="button" class="btn btn-outline-danger"
            [disabled]="saving || reason.invalid"
            [attr.aria-busy]="saving"
            (click)="submit()"
            data-testid="deactivate-organisation-submit">
        Yes, proceed
    </button>
</div>
